import { SalesSites } from './sales-sites.component.js';

export * from './sales-sites.component.js';
export default SalesSites;

SalesSites.define('der-tailormade-booking-request-sales-sites');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-booking-request-sales-sites': SalesSites;
    }
}
